import { SharedPacksController } from './shared-packs.controller'

function sharedPacks () {
  return {
    scope: {},
    restrict: 'E',
    templateUrl: '/repository/directives/shared-packs/shared-packs.html?$$REVISION$$',
    controller: SharedPacksController
  }
}

export { sharedPacks }
